export default __webpack_public_path__ + "static/media/ordericon.645a160f.svg";